import React from 'react';
import { Carousel } from 'react-bootstrap';

const ContentCarousel = ({ contents = [] }) => {
  return (
    <Carousel controls={false}>
      {contents.map((content, index) => (
        <Carousel.Item key={index}>
          {content.content}
        </Carousel.Item>
      ))}
    </Carousel>
  )
}

export default ContentCarousel